import { useRouter } from 'vue-router';

function useNavigate() {
	const router = useRouter();

	const goBack = (path = '') => {
		if (path) router.push(path);
		else router.back();
	};

	const push = (pushParam) => {
		router.push(pushParam);
	};

	return {
		goBack,
		push,
	};
}

export default useNavigate;
